// getChoiceLabels.js
export const getChoiceLabels = (format, count) => {
    const formats = {
        1: ["a)", "b)", "c)", "d)", "e)", "f)"],
        2: ["A)", "B)", "C)", "D)", "E)", "F)"],
        3: ["1)", "2)", "3)", "4)", "5)", "6)"],
        4: ["i)", "ii)", "iii)", "iv)", "v)", "vi)"],
    };
    const selectedFormat = formats[Number(format)] || formats[2];
    return selectedFormat.slice(0, count);
};

export const questionTypeMapUI = {
    1: "MCQ",
    2: "SCQ",
    3: "True/False",
    4: "Numerical",
};